import type React from 'react';
import { Card, Skeleton } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';

const PLACEHOLDER_ROW_COUNT = 5;
const COLUMN_COUNT = 7;

/** Placeholder rows for the register's first load, one cell per column. */
export const ShiftRegisterSkeleton: React.FC = () => (
    <Card className="overflow-hidden p-0">
        <div
            aria-busy
            className="divide-y divide-border"
            {...getNodeTestIdProp('shift-register-skeleton')}
        >
            {Array.from({ length: PLACEHOLDER_ROW_COUNT }).map((_, row) => (
                <div
                    className="grid grid-cols-7 gap-4 px-4 py-3"
                    // Fixed-count placeholder rows, never reordered.
                    key={row}
                >
                    {Array.from({ length: COLUMN_COUNT }).map((__, cell) => (
                        <Skeleton className="h-4 rounded-md" key={cell} />
                    ))}
                </div>
            ))}
        </div>
    </Card>
);
